import { z } from 'zod';

export enum ExploreColumnType {
  DISTANCE = 'DISTANCE',
  LOAD = 'LOAD',
  SHOTS = 'SHOTS',
  SPRINTS = 'SPRINTS',
}

export const exploreColumnTypeSchema = z.enum(ExploreColumnType);
